import React from 'react';

const Homepage = () => {
  return (<div>
    <h1 className="center">Homepage</h1>
  </div>);
}
export default Homepage;



// WEBPACK FOOTER //
// ./src/Component/Homepage.js